import { GetOcr } from 'shared/data/webApp/v2';

import { AddressLinesItem, FormValues, VendorType } from '../../NetSuiteVendorCreationPopupContent.types';
import { defaultAddressLine } from './NetSuiteVendorCreationPopupForm.constants';
import { GetFormDefaultValuesParams } from './NetSuiteVendorCreationPopupForm.types';

const extractOcrCurrency = (
    ocrDocument: GetOcr['response']['document'],
    currenciesMap: GetFormDefaultValuesParams['currenciesMap']
) => {
    return ocrDocument?.currencyCode
        ? {
              id: ocrDocument.currencyCode,
              text: currenciesMap.get(ocrDocument.currencyCode)?.text || '',
          }
        : null;
};

const extractOcrAddress = (ocrDocument: GetOcr['response']['document']) => {
    return ocrDocument?.vendor?.address
        ? {
              ...defaultAddressLine,
              primaryAddress: ocrDocument.vendor.address?.street || '',
              city: ocrDocument.vendor.address?.city || '',
              zip: ocrDocument.vendor.address?.postalCode || '',
              state: ocrDocument.vendor.address?.region || '',
          }
        : null;
};

export const getFormDefaultValues = (params: GetFormDefaultValuesParams) => {
    const { defaultSubsidiaryId, defaultCurrencyId, ocrData, currenciesMap } = params;

    const ocrCurrency = extractOcrCurrency(ocrData?.document, currenciesMap);
    const ocrAddress = extractOcrAddress(ocrData?.document);

    const addressLines: AddressLinesItem[] = ocrAddress ? [ocrAddress] : [defaultAddressLine];

    const primaryCurrencyId = ocrCurrency?.id || defaultCurrencyId;

    const formDefaultValues: FormValues = {
        vendorType: VendorType.Company,
        companyName: ocrData?.document?.vendor?.name || '',
        taxNumber: ocrData?.document?.vendor?.taxNumber || '',
        primarySubsidiaryId: defaultSubsidiaryId,
        subsidiaries: [
            {
                subsidiaryId: defaultSubsidiaryId,
                creditLimit: null,
                taxCodeId: null,
            },
        ],

        is1099Eligible: false,
        isJobResource: false,

        currencyId: primaryCurrencyId,
        currenciesIds: primaryCurrencyId ? [primaryCurrencyId] : [],

        addressLines,
    };

    return formDefaultValues;
};
